import { render, staticRenderFns } from "./GeneralTodoList.vue?vue&type=template&id=976b8266&"
import script from "./GeneralTodoList.vue?vue&type=script&lang=js&"
export * from "./GeneralTodoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports